import { inject, InjectionKey } from "vue";
import { registerStore } from "../../core/store";
import { State } from "../../core/store/types";
import { htmlEditorStoreFeatures } from "./features";
import { HTMLEditorSetup, HTMLEditorStoreFeatures, HTMLEditorStoreSetup, HTMLEditorStoreState } from "./types";

export const htmlEditorStoreKey: InjectionKey<HTMLEditorStoreState> = Symbol("htmlEditorStore");
export const htmlEditorStore = registerStore<HTMLEditorStoreFeatures, ReturnType<typeof setupStore>, ReturnType<typeof setupState>>(htmlEditorStoreKey, htmlEditorStoreFeatures, setupStore, setupState);

function setupStore(): HTMLEditorStoreSetup
{
    const setup: HTMLEditorStoreSetup =
    {
        defaultHTMLEditorId: "HTMLEditor",
        get defaultHTMLEditorPromise(): Promise<HTMLEditorStoreState>
        {
            return htmlEditorStore.getStateAsync(this.defaultHTMLEditorId)
        },
        injectHTMLEditorState,
    };

    return setup;

    function injectHTMLEditorState(): HTMLEditorStoreState
    {
        return inject(htmlEditorStoreKey, undefined) as HTMLEditorStoreState;
    }
}

function setupState(htmlEditorID: string, _storeState: State<HTMLEditorStoreFeatures, {}, {}>): HTMLEditorSetup
{
    const state =
    {
        get htmlEditorID() { return htmlEditorID; },
    };

    return state;
}
